import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {styled} from "@mui/material";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import RpIcon from "@/components/RpIcon";

import "dayjs/locale/en";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-hk";
import "dayjs/locale/th";
import "dayjs/locale/ar";
import "dayjs/locale/tr";
import "dayjs/locale/fr";
import "dayjs/locale/ko";
import "dayjs/locale/ja";
import "dayjs/locale/pt";
import "dayjs/locale/es";

import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as preParsePostFormat from 'dayjs/plugin/preParsePostFormat'

// dayjs.extend(localizedFormat);
// dayjs.extend(preParsePostFormat);

const StyledDatePicker = styled(DesktopDatePicker)(({theme}) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: `${theme.palette.background.default}`,
    borderRadius: '2px',
  }
}));
const AppDatePicker = props => {
  const {t, i18n} = useTranslation();
  const [locale, setLocale] = useState("en");
  const value = props.value ? dayjs(props.value) : null;
  const onChange = props?.onChange;

  useEffect(() => {
    if (i18n.language === "en") {
      setLocale("en");
    } else if (i18n.language === "hk") {
      setLocale("zh-hk");
    } else if (i18n.language === "kr") {
      setLocale("ko");
    }else if (i18n.language === "cn") {
      setLocale("zh-cn");
    } else if (i18n.language === "ar") {
      setLocale("ar-SA");
    } else {
      setLocale(i18n.language);
    }
  }, [t]);

  const onHandleChange = (event) => {
    onChange && onChange(event?.$d);
  };

  return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
    <StyledDatePicker
      {...props}
      value={value}
      onChange={onHandleChange}
      // components={{
      //   OpenPickerIcon: () => <RpIcon icon="calendar" size={15} style={{padding: '20px'}}/>,
      // }}
      slots={{
        openPickerIcon: () => <RpIcon icon="calendar" size={18} />,
      }}
    />
  </LocalizationProvider>;
};

export default AppDatePicker;